import { Children } from "react";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "semantic-ui-react";
import { Card } from "./layout";
import { ui } from "./styles";

// Semantic Table in the app's table chrome. Header styling is in semantic.css
// (.sk-table-card). columns: [{ key, label, width (1-16), align, style }].
// rowGroups: children are <tbody>s (one per record), so no TableBody wrapper.
export function DataTable({
  columns,
  children,
  empty,
  scroll,
  bare,
  rowGroups,
  className,
  ...tableProps
}) {
  const rows = Children.toArray(children);
  const emptyRow = empty != null && rows.length === 0 && (
    <tr>
      <td
        colSpan={columns?.length || 1}
        style={{ ...ui.muted, padding: "16px" }}
      >
        {empty}
      </td>
    </tr>
  );

  let table = (
    <Table basic="very" inverted {...tableProps}>
      {columns && (
        <TableHeader>
          <TableRow>
            {columns.map((c) => (
              <TableHeaderCell
                key={c.key}
                width={c.width}
                textAlign={c.align}
                style={c.style}
              >
                {c.label}
              </TableHeaderCell>
            ))}
          </TableRow>
        </TableHeader>
      )}
      {rowGroups ? (
        <>
          {emptyRow && <tbody>{emptyRow}</tbody>}
          {rows}
        </>
      ) : (
        <TableBody>
          {emptyRow}
          {rows}
        </TableBody>
      )}
    </Table>
  );

  // Scrolls sideways in its own box so the card can stay overflow-free
  if (scroll) table = <div className="sk-table-scroll">{table}</div>;
  if (bare) return table;
  return (
    <Card
      flush
      className={["sk-table-card", className].filter(Boolean).join(" ")}
    >
      {table}
    </Card>
  );
}
